import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IDishAssignmentContext,
	DishAssignmentContext,
} from '../../../../../dishAssignmentState/dishAssignmentContext';
import SelectedItemForBreadcrumbs from 'components/SelectedItem/SelectedItemForBreadcrumbs';
import style from './CategoryCrumb.module.scss';

const CategoryCrumb: React.FC = () => {
	const { setIDsSelectedCategories, categories, IDsSelectedCategories } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const deleteCategory = (categoryID: string) => {
		const copyIDsSelectedCategories = { ...IDsSelectedCategories };
		delete copyIDsSelectedCategories[categoryID];
		setIDsSelectedCategories(copyIDsSelectedCategories, true);
	};

	return (
		<div className={style.container} data-test="CategoryCrumb">
			<div className={style.scrollWrapper}>
				<Text
					className={style.crumbName}
					translationNameSpace="listing"
					translationKey="categoriesLabel"
					size="s"
					weight="bold"
				/>
				<div className={style.selectedItemWrapper}>
					{categories.map((category) => {
						if (category.id in IDsSelectedCategories) {
							return (
								<SelectedItemForBreadcrumbs
									key={category.id}
									label={category.name || ''}
									onDelete={() => deleteCategory(category.id)}
								/>
							);
						}
					})}
				</div>
			</div>
		</div>
	);
};

export default CategoryCrumb;
